import { Component, OnInit, inject, PLATFORM_ID } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ButtonModule } from 'primeng/button';
import { SanitizeHtmlTextPipe } from './shared/pipes/sanitize-html-text.pipe';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { ThemeService } from './services/theme.service';
import { CommonModule } from '@angular/common';
import { faCircleInfo, faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { PreviewService } from './services/preview.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet,
    Toast,
    ConfirmDialogModule,
    ButtonModule,
    SanitizeHtmlTextPipe,
    CommonModule, FaIconComponent, FontAwesomeModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})

export class AppComponent implements OnInit {
  private router = inject(Router);
  private ar = inject(ActivatedRoute);
  private theme = inject(ThemeService);
  private oidcSecurityService = inject(OidcSecurityService);
  private platformId = inject(PLATFORM_ID);
  private previewService = inject(PreviewService);
  title = 'auction-frontend';
  protected readonly faCircleQuestion = faCircleQuestion;
  protected readonly faCircleInfo = faCircleInfo;

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) return; // avoid SSR/hydration flicker

    if (this.previewService.isPreview) {
      // Preview renders passed-in data only: no auth provider or backend calls.
      this.previewService.start();
    } else {
      this.oidcSecurityService.checkAuth().subscribe();
    }

    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => {
        // Walk to deepest child to read its data
        let r: ActivatedRoute | null = this.ar;
        while (r?.firstChild) r = r.firstChild;

        const wanted = (r?.snapshot.data['theme'] ?? 'bfg') as 'bfg' | 'community';
        if (wanted === 'community') {
          this.theme.setPreset(wanted);
        }
      });
  }
}
